import { Button } from '@components/button';
import { Typography } from '@components/typography';
import { Box, Stack, useTheme } from '@mui/material';

export const GettingStartedAction = ({
  imageUrl,
  imageContent,
  title,
  description,
  action,
  actionLabel,
}: {
  imageUrl?: string;
  imageContent?: React.ReactNode;
  title: string;
  description: string;
  action: () => void;
  actionLabel: string;
}) => {
  const { palette } = useTheme();
  return (
    <Stack
      width="292px"
      p={4}
      gap={4}
      alignItems="center"
      borderRadius={2}
      sx={{
        border: `1px solid transparent`,
        cursor: 'pointer',
        backgroundColor: palette.background.default,
        '&:hover': {
          border: `1px solid ${palette.grey[700]}`,
          backgroundColor: palette.backgroundHover.default,
        },
      }}
      onClick={action}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt={title}
          style={{
            width: 'calc(100% + 34px)',
            borderRadius: '8px',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            border: `1px solid ${palette.grey[900]}`,
            marginTop: '-17px',
            marginLeft: '-16px',
            marginRight: '-16px',
          }}
        />
      )}
      {imageContent && (
        <Box
          sx={{
            width: 'calc(100% + 34px)',
            aspectRatio: '1172/657',
            borderRadius: '8px',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            border: `1px solid ${palette.grey[900]}`,
            marginTop: '-17px',
            marginLeft: '-16px',
            marginRight: '-16px',
            backgroundColor: palette.background.default,
          }}
        >
          {imageContent}
        </Box>
      )}
      <Typography variant="subtitle1" maxWidth="150px" textAlign="center">
        {title}
      </Typography>
      <Typography variant="body2" textAlign="center" color={palette.text.primary}>
        {description}
      </Typography>
      <Box flex={1} />
      <Button variant="accent" sx={{ justifySelf: 'flex-end' }}>
        {actionLabel}
      </Button>
    </Stack>
  );
};
